var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcConversation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#EFF6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 19.3333C22.6666 19.687 22.5261 20.0261 22.2761 20.2761C22.026 20.5262 21.6869 20.6667 21.3333 20.6667H12.5519C12.1983 20.6667 11.8592 20.8073 11.6093 21.0573L10.1413 22.5253C10.0751 22.5915 9.99072 22.6366 9.89891 22.6548C9.8071 22.6731 9.71194 22.6637 9.62546 22.6279C9.53897 22.5921 9.46505 22.5314 9.41304 22.4536C9.36103 22.3758 9.33326 22.2843 9.33325 22.1907V11.3333C9.33325 10.9797 9.47373 10.6406 9.72378 10.3905C9.97382 10.1405 10.313 10 10.6666 10H21.3333C21.6869 10 22.026 10.1405 22.2761 10.3905C22.5261 10.6406 22.6666 10.9797 22.6666 11.3333V19.3333Z",
    stroke: "#155DFC",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConversation);
export default __webpack_public_path__ + "static/media/ic_conversation.153292f36784a1efef00e9806d29685d.svg";
export { ForwardRef as ReactComponent };